import { Box, Icon } from "@mui/material"
import { useStyles } from "./styles"
import { icons } from "../../../../utils/icons"
import { useTranslation } from "react-i18next"
import { BreadCrumb, SnackSimple } from "../../../../components"
import SimpleModal from "../../../../components/modal/simpleModal"
import Loader from "../../../../components/loader"
import { Header } from "./fragments"
import { OptionActions } from "../../components/optionActions"
import { Section } from "./fragments/section"
import { useQuestionnaireContext } from "./contextProvider"
import { deleteDecimalsWithZero } from "../../../../utils/methods/removeDecimals"
import StatusComponent from "../../../../components/status"
import { getStatus } from "../../../../hooks/status"
import { Status } from "../../../../utils/enums"
import { useContextState } from "../../../../hooks/theme"
import { useMemo } from "react"

const Detail = () => {
  const { t } = useTranslation()
  const styles = useStyles()
  const { colors } = useContextState()
  const { closeModal, dataHeader, modal, handleNavigate, isSectionConfig, openGeneralConfig, isGeneral, sectionList, loading, refOptions, createQuestionnaire, saveGeneralConfig, closeSnackbar, snackbar, openConfig, generalconfig, averagePoints, headerConfig, questionTotal, loadings } = useQuestionnaireContext()
  const sectinListLength = sectionList.length
  const typeStatus = useMemo(() => getStatus(dataHeader?.statusId as Status, colors, t),[dataHeader?.statusId])
  if (!!loadings.main) return <Loader />
  return (
    <Box sx={[styles.container, !!loadings.main ? styles.overflowHidden : {}]}>
      <BreadCrumb
        Children={(
          <StatusComponent type="chip" color={typeStatus?.color} msg={typeStatus?.text} />
        )}
      />

      <Header
        averagePoints={averagePoints}
        dataHeader={dataHeader}
        actionPlan={isGeneral}
        handleNavigate={handleNavigate}
        isSectionConfig={isSectionConfig}
        loadings={loadings}
        openGeneralConfig={openGeneralConfig}
        view="edit"
        detail={{
          id: dataHeader?.parentId?.toString() || '',
          version: dataHeader?.version?.toString() || '1'
        }}
      />

      {
        Boolean(openConfig) && (
          <OptionActions
            idKey={openConfig}
            display={{ actionPlan: Boolean(isGeneral), evidence: false, reportFolio: false, comments: true, permitting: true, reportSignature:true }}
            save={saveGeneralConfig}
            permission={() => {
              // changeView({ type: 'permissions' })
            }}
            defaults={generalconfig}
            ref={(element) => refOptions({ element, name: 'general' })}
            header={headerConfig}
            averagePoints={isSectionConfig && averagePoints ? deleteDecimalsWithZero(Number(averagePoints / sectinListLength).toFixed(2)) : averagePoints}
            questionAmount={questionTotal}
            sectionAmount={sectinListLength}
            drawerProps={{ open: Boolean(openConfig), anchor: 'right' }}
            footerButtons={{
              left: {
                click: () => { createQuestionnaire({ save: true }) },
                label: t('general.saveAndFinished')
              },
              right: {
                click: () => {
                  createQuestionnaire({ ignoreEdit: true, save: true, draft: true })
                },
                loading: !!loading.modal,
                label: t('general.saveDraft')
              },
            }}
          />
        )
      }

      <Section key={'section'} />

      <SnackSimple close={closeSnackbar} open={snackbar.open} type={snackbar.type} message={snackbar.message} />

      <SimpleModal
        icon={!!modal?.icon ? <Icon sx={styles.warningIcon}>{icons(modal.icon)}</Icon> : undefined}
        open={!!modal.open}
        close={() => {
          if (modal.close) { modal.close() }
          else if (modal.cancel) { modal.cancel() }
          else { closeModal() }
        }}
        title={modal.title}
        removeClose={!modal.cancel && !modal.close}
        description={modal.description}
        cancelText={modal.cancelText ?? t('general.cancel')}
        buttonText={modal?.confirmText ?? t('general.confirm')}
        back={modal.cancel ? () => { if (modal.cancel) modal.cancel() } : undefined}
        loadingButton
        isLoading={!!loadings.modal}
        next={() => {
          if (modal.confirm) modal.confirm()
          else { closeModal() }
        }}
      />
    </Box>
  )
}

export { Detail }
